import { Component } from 'react';

export class SearchSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;
        return (
            <svg
                className={className}
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    width="20"
                    height="20"
                    fill="black"
                    fillOpacity="0"
                    transform="translate(0.42749 0.133789)"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.647949 19.9131C0.790649 20.0557 0.979858 20.1338 1.18127 20.1338C1.38257 20.1338 1.57202 20.0557 1.71448 19.9131L6.90454 14.7227C8.3822 15.9551 10.2433 16.6299 12.1792 16.6299C14.3826 16.6299 16.4536 15.7715 18.0115 14.2139C19.5696 12.6562 20.4275 10.585 20.4275 8.38184C20.4275 6.17871 19.5693 4.10742 18.0115 2.5498C16.4536 0.992188 14.3826 0.133789 12.1792 0.133789C9.97607 0.133789 7.90491 0.992188 6.3468 2.5498C3.32043 5.5752 3.12061 10.3965 5.83813 13.6562L0.647949 18.8467C0.354004 19.1406 0.354004 19.6191 0.647949 19.9131ZM7.41345 3.61523C8.6864 2.34277 10.3788 1.6416 12.1791 1.6416C13.979 1.6416 15.6716 2.34277 16.9446 3.61523C18.2175 4.88867 18.9186 6.58105 18.9186 8.38086C18.9186 10.1807 18.2175 11.874 16.9446 13.1465C15.6719 14.4199 13.9792 15.1201 12.1791 15.1201C10.379 15.1201 8.6864 14.4199 7.41345 13.1465C6.14258 11.876 5.44263 10.1836 5.44263 8.38086C5.44263 6.5791 6.14282 4.88574 7.41345 3.61523Z"
                    fill="#767676"
                />
            </svg>
        );
    }
}
